import React, { useState, useEffect, useRef } from 'react';
import { Form, Tooltip, Button,Table } from 'antd';
import 'braft-editor/dist/index.css';
import * as REQUEST from "../../common/request";
import Page from '../../components/page';
import './index.less';

const PageModel = props => {
  const [form] = Form.useForm();

  const [imageFileList, setImageFileList] = useState([]);
  const [detailValue, setDetailValue] = useState(null);
  const [modalFormObj, setModalFormObj] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const closeModalHandle = () => {
    setImageFileList([]);
    setModalVisible(false);
    setModalFormObj(null);
    setDetailValue(null);
    setTimeout(() => {
      form.resetFields();
    }, 20);
  };

  const [list, setList] = useState([]);
  const getList = async () => {
    const result = await REQUEST.get({
      url: '/zhujiajiao/v2/admin/comp/list'
    });
    if (!result) return;

    result.data.list.map(item => {
      item.key = item.id;
      return item;
    });
    setList(result.data.list);
  };
  useEffect(() => {
    getList();

    return () => false;
  }, [123]);
  
  console.log('detailValue', detailValue, modalFormObj)
  return (
    <Page {...{
      ...props,
      breadcrumbs: [{ label: '首页' }, { label: '投诉建议' }],
      title: '投诉建议'
    }}>
      <section className="guide-container" style={{ minHeight: window.innerHeight }}>
        <div className="intro-top">
          <Button type="primary" onClick={async () => {
            // setModalVisible(true);
            // form.resetFields();


            const result = await REQUEST.get({
              url: '/zhujiajiao/v2/admin/comp/export'
            });
            if (!result) return;
            window.open(result.data.path);

          }}>导出</Button>
        </div>
        <Table {...{
          size: 'small',
          locale: { emptyText: '暂无数据' },
          dataSource: list,
          columns: [
            {
              title: '投诉内容', dataIndex: 'content', key: 'content',width:600,
              render: (text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            },
            {
              title: '时间', dataIndex: 'createdAt', key: 'createdAt', ellipsis: { showTitle: false },
              render: (text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            },
            {
              title: '姓名', dataIndex: 'name', key: 'name', ellipsis: { showTitle: false },
              render: (text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            },
            {
              title: '联系方式', dataIndex: 'tel', key: 'tel', ellipsis: { showTitle: false },
              render: (text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            },
            // {
            //   title: '操作', dataIndex: 'edit', key: 'edit', width: 156, fixed: 'right',
            //   render: (text, record, index) => {
            //     const _style = { marginRight: 10, fontSize: 12 };
            //     return <>
            //       <Button size="small" type="primary" ghost style={_style} onClick={() => {
            //         const _record = { ...record };
            //         setModalFormObj(_record);
            //         if (_record.detail) {
            //           const detailValue = BraftEditor.createEditorState(_record.detail);
            //           setDetailValue(detailValue);
            //         }
            //         if (_record.link && _record.link.length > 0) {
            //           setImageFileList([_record.link]);
            //         }

            //         form.setFieldsValue({ ...record });
            //         setModalVisible(true);
            //       }}>编辑</Button>
            //       <Button type="text" danger size="small" style={_style} onClick={() => {
            //         Modal.confirm({
            //           title: '删除的数据将无法找回，请慎重操作！',
            //           icon: <WarningOutlined style={{ color: '#E45357' }} />,
            //           // content: 'Bla bla ...',
            //           okText: '确认删除',
            //           cancelText: '取消',
            //           onOk: () => {
            //             deleteHandle(record.id);
            //           },
            //           onCancel: () => {
            //             // console.log('Cancel');
            //           },
            //         });
            //       }}>删除</Button>
            //     </>
            //   }
            // },
          ]
        }} />
      </section>

    </Page>
  );
};

export default PageModel;
